export const charIsHex = (char: string) => {
  return !isNaN(parseInt(char, 16))
}

export const parseUnit = (value: number | string) => {
  let unit = 'px'
  let val = 0
  if (typeof value === 'string') {
    const unitMatch = value.match(/[^0-9.]/g)
    if (unitMatch) {
      unit = unitMatch.join('')
    }
    const valMatch = value.match(/[0-9.]+/g)
    if (valMatch) {
      val = parseFloat(valMatch.join(''))
    }
  } else {
    val = value
  }
  return {
    unit,
    val,
  }
}

/**
 * Credits https://www.delftstack.com/de/howto/javascript/javascript-round-to-2-decimal-places/
 * @param num
 * @returns
 */
export const roundToTwo = (num: number) => {
  return +(Math.round((num + 'e+2') as any) + 'e-2')
}
